import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

export function useAbortableAsyncThunk(asyncThunk, dependency) {
  const promiseRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (promiseRef.current) {
      promiseRef.current.abort();
    }

    return () => {
      if (promiseRef.current) {
        promiseRef.current.abort();
      }
    };
  }, [dependency]);

  const dispatchWithAbort = async (params) => {
    const promise = dispatch(asyncThunk(params));
    promiseRef.current = promise;

    return promise;
  };

  return {
    dispatchWithAbort,
  };
}
